import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/bootstrap-icons/font/bootstrap-icons.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/flag-icons/css/flag-icons.min.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@react-pdf-viewer/core/lib/styles/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@react-pdf-viewer/default-layout/lib/styles/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReCaptcha"] */ "/app/node_modules/next-recaptcha-v3/lib/ReCaptcha.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReCaptchaContext","ReCaptchaProvider","useReCaptchaContext"] */ "/app/node_modules/next-recaptcha-v3/lib/ReCaptchaProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["useReCaptcha"] */ "/app/node_modules/next-recaptcha-v3/lib/useReCaptcha.js");
;
import(/* webpackMode: "eager", webpackExports: ["withReCaptcha"] */ "/app/node_modules/next-recaptcha-v3/lib/withReCaptcha.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer","Bounce"] */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/app/global.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Hind\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"700\"],\"display\":\"swap\"}],\"variableName\":\"hind\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/telemetry/NavigationHealthMonitor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/telemetry/PresenceHeartbeatMonitor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/contextApi/AppProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/redux/provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/style/index.scss");
